import classNames from 'classnames';
import * as React from 'react';
import type { LanguageViewModel } from '~/Features/Navigation/LanguageViewModel.csharp';
import { Link } from '~/Partials/Link/Link';
import { LinkType } from '~/Partials/Link/LinkType.csharp';
import {
    buildAbsoluteUrlWithQueryParameters,
    useQueryParametersObserver,
} from '~/Partials/SearchBase/QueryParameterUtils';
import { SvgIcon } from '~/Partials/SvgIcon/SvgIcon';
import styles from './LanguagePicker.module.css';

interface StickyLanguagePickerProps {
    language: LanguageViewModel;
    variant: 'sticky' | 'inline' | 'stickyNarrow';
}

export const LanguagePicker: React.FC<React.PropsWithChildren<StickyLanguagePickerProps>> = props => {
    const { language, variant } = props;
    const additionalQueryParams = useQueryParametersObserver();

    return (
        <Link
            href={buildAbsoluteUrlWithQueryParameters(language.url, additionalQueryParams)}
            className={classNames(
                styles.StickyLanguagePicker,
                variant === 'stickyNarrow'
                    ? [styles[`Variant--sticky`], styles['Variant--stickyNarrow']]
                    : styles[`Variant--${variant}`]
            )}
            lang={language.code}
            type={LinkType.Clear}
        >
            <div className={styles.Content}>
                <SvgIcon className={styles.Icon} iconName="globe" />
                <p className={styles.Label}>{language.label}</p>
            </div>
        </Link>
    );
};
